import { Star } from "lucide-react";

const T = [
    {
        quote:
            "The teachers go beyond the syllabus — they prepare you for hospital and retail pharmacy with real-world case studies. I felt confident from day one of my internship.",
        name: "Riya Mondal",
        role: "D.Pharm Alumna, Hospital Pharmacist",
    },
    {
        quote:
            "From the labs to the library, every facility is genuinely useful. The faculty&rsquo;s open-door policy made it easy to clear doubts even after class hours.",
        name: "Subhajit Das",
        role: "D.Pharm Final Year",
    },
    {
        quote:
            "Coming from a small village, the hostel and scholarship support changed my life. Today I run my own community pharmacy in Birbhum.",
        name: "Anjali Khatun",
        role: "Alumna, Community Pharmacist",
    },
];

export const Testimonials = () => (
    <section
        id="testimonials"
        data-testid="testimonials-section"
        className="relative py-24 lg:py-32 bg-gradient-to-b from-stone-50 to-stone-100/60"
    >
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
            <div className="text-center max-w-2xl mx-auto reveal">
                <span className="section-rule eyebrow mx-auto">Voices from Campus</span>
                <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-5 leading-[1.05] text-stone-900">
                    Stories from our <em className="not-italic text-[var(--brand-blue)]">students</em>.
                </h2>
            </div>

            <div className="mt-14 grid md:grid-cols-3 gap-5 lg:gap-6">
                {T.map((t, i) => (
                    <figure
                        key={t.name}
                        data-testid={`testimonial-${i}`}
                        className={`tactile-card p-7 md:p-8 reveal delay-${i + 1} flex flex-col`}
                    >
                        <div className="flex gap-1 text-[var(--brand-yellow)]">
                            {[0, 1, 2, 3, 4].map((s) => (
                                <Star key={s} size={16} fill="currentColor" strokeWidth={0} />
                            ))}
                        </div>
                        <blockquote
                            className="mt-5 text-stone-700 leading-relaxed font-display text-xl md:text-[22px]"
                            dangerouslySetInnerHTML={{ __html: `&ldquo;${t.quote}&rdquo;` }}
                        />
                        <figcaption className="mt-6 pt-5 border-t border-stone-200">
                            <div className="font-medium text-stone-900">{t.name}</div>
                            <div className="text-xs uppercase tracking-[0.16em] text-stone-500 mt-1">
                                {t.role}
                            </div>
                        </figcaption>
                    </figure>
                ))}
            </div>
        </div>
    </section>
);

export default Testimonials;
